module.exports = __webpack_public_path__ + "static/img/shuzihua.fd67ea9.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/digitalsoftware/shuzihua.png
// module id = B7AD
// module chunks = 1